
import { defineComponent, ref } from 'vue';
import { useList } from '@/hooks/use-list';
import {
  getApproveList,
  updatePublicServiceState,
  updateDeprecatedState,
  getLogList,
} from '@/api/project-service';
import type {
  IManageProjectPageListItem,
  IManageProjectPageReq,
  IModifyStateReq,
} from '@/api/project-service/type.d';
import {
  BUSINESS_TYPE_LIST,
  DEPARTMENT_TYPE_LIST,
  REVIEW_STATE_ENUM,
  REVIEW_STATE_LIST,
  ENVIRONMENT_TYPE_LIST,
  IS_DELETE_LIST,
  IS_RETAIN_LIST,
  IS_DELETE_ENUM,
} from '@/constant/project-service';
import AddDialog from './components/add-dialog';
import EditDialog from './components/edit-dialog';
import usePermissionConfig from './use-permission-config';
import OperationDrawer from '@/components/operation-drawer/index.vue';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
import { UserItem } from '@/api/auth-manage/user/type.d';
import { fuzzyQueryUser } from '@/api/auth-manage/user/index';
import { useFuzzy } from '@/hooks/use-fuzzy';

export default defineComponent({
  components: {
    AddDialog,
    EditDialog,
    OperationDrawer,
  },
  setup() {
    const route = useRoute();
    // const isDisabled = ref<boolean>(true);
    const serviceName = route.params.serviceName as string;
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IManageProjectPageListItem, IManageProjectPageReq>({
      request: {
        api: getApproveList,
        params: {
          businessType: '',
          department: '',
          groupName: '',
          serviceName: '',
          firstHeadOfBackend: '',
          secondHeadOfBackend: '',
          reviewState: '',
          gatewayRouting: '',
          isPublicService: '',
          isDeprecated: '',
          pageNum: 1,
          pageSize: 20,
        },
        handleParams(paramsObj) {
          return paramsObj;
        },
      },
    });

    const {
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
    } = useFuzzy<any, UserItem[]>({
      params: { keyword: '' },
      keywordKey: 'keyword',
      API: fuzzyQueryUser,
      beforeRequest(param, query) {
        return query;
      },
      beforeResponse(res) {
        return res.data?.map((user: UserItem) => {
          const { name: label, userId: value } = user;
          return { ...user, label, value };
        });
      },
    });

    const handleChangeUser = (userInfo: UserItem) => {
      params.value.firstHeadOfBackend = userInfo.name;
    };

    const handleChangeAlternativeUser = (userInfo: UserItem) => {
      params.value.secondHeadOfBackend = userInfo.name;
    };

    const addFormConfig = ref({
      visible: false,
      id: '',
    });
    const handleAddApproveInfo = (row?: IManageProjectPageListItem) => {
      addFormConfig.value.visible = true;
      addFormConfig.value.id = row?.serviceId ?? '';
    };

    const editFormConfig = ref({
      visible: false,
      approveInfo: {} as IManageProjectPageListItem,
    });
    const handleEditApproveInfo = (row: IManageProjectPageListItem) => {
      editFormConfig.value.visible = true;
      editFormConfig.value.approveInfo = row;
    };

    const handleEidtSuccess = () => {
      handleSearch(params.value.pageNum as number);
    };

    const deprecatedData = ref({
      visible: false,
      data: {} as IManageProjectPageListItem,
    });
    const openStayDialog = (row: IManageProjectPageListItem) => {
      deprecatedData.value.visible = true;
      deprecatedData.value.data = row;
    };
    const handleClose = () => {
      deprecatedData.value.visible = false;
    };
    const handleConfirm = async () => {
      const { data } = deprecatedData.value;
      deprecatedData.value.visible = false;
      const state = data.isDeprecated === IS_DELETE_ENUM.YES ? IS_DELETE_ENUM.NO : IS_DELETE_ENUM.YES;
      await updateDeprecatedState({
        serviceId: data.serviceId,
        state,
        serviceName: data.serviceName,
      });
      data.isDeprecated = state;
    };

    // 更新是否公共服务状态触发函数
    const changePublicService = async (row: IManageProjectPageListItem) => {
      if (row.isDeprecated === '1') {
        const data: IModifyStateReq = {
          serviceId: row.serviceId,
          state: row.isPublicService,
          serviceName: row.serviceName,
        };
        await updatePublicServiceState(data);
        ElMessage.success('更改成功');
      }
    };

    // 操作日志
    const logData = ref({
      visible: false,
      id: '',
    });
    const openLogDrawer = (row: IManageProjectPageListItem) => {
      console.log(row);
      logData.value.visible = true;
      logData.value.id = row.serviceId;
      console.log(logData.value);
    };

    const handleDialog = (row: IManageProjectPageListItem) => {
      if (row.reviewState === REVIEW_STATE_ENUM.REVIEWED) {
        handleEditApproveInfo(row);
      }
      if (row.reviewState === REVIEW_STATE_ENUM.REJECT) {
        handleAddApproveInfo(row);
      }
    };

    const init = () => {
      params.value.serviceName = serviceName ?? '';
      handleSearch();
    };

    init();
    const permissionConfig = usePermissionConfig();

    const ableEditBtn = (row: IManageProjectPageListItem) => {
      return (
      [
        REVIEW_STATE_ENUM.REVIEWED,
        REVIEW_STATE_ENUM.REJECT,
      ] as string[]).includes(row.reviewState)
      && row.isDeprecated === IS_DELETE_ENUM.YES;
    };
    return {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      deprecatedData,
      BUSINESS_TYPE_LIST,
      DEPARTMENT_TYPE_LIST,
      REVIEW_STATE_ENUM,
      REVIEW_STATE_LIST,
      ENVIRONMENT_TYPE_LIST,
      IS_DELETE_LIST,
      IS_RETAIN_LIST,
      addFormConfig,
      editFormConfig,
      handleAddApproveInfo,
      handleEditApproveInfo,
      handleEidtSuccess,
      openStayDialog,
      handleClose,
      handleConfirm,
      changePublicService,
      openLogDrawer,
      handleDialog,
      getLogList,
      ableEditBtn,
      handleChangeUser,
      handleChangeAlternativeUser,
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
      logData,
      permissionConfig,
      IS_DELETE_ENUM,
      config: {
        timeKey: 'createdTime',
        userKey: 'creatorName',
        contentKey: 'logContent',
        remarkKey: 'remark',
      },
    };
  },
});
